import { List } from 'immutable';
export const isList = val => {
  return List.isList(val);
};
export const isNotNull = value => value != null;
export function assertUnreachable(__x, message = 'Exhaustive check was insufficient') {
  throw new Error(message);
}